/** Figma app shell — standard main content padding for list and workspace pages. */
export const APP_SHELL_PAGE_PADDING_PX = 32

export const APP_SHELL_PAGE_TITLE_SUBTITLE_GAP_PX = 4
export const APP_SHELL_PAGE_TITLE_ROW_MARGIN_BOTTOM_PX = 20
